import React, { useEffect, useState } from "react";
import { Box, Button, ButtonGroup, Flex, Stack, useMediaQuery } from "@chakra-ui/react";
import FavoriteButton from "../../Content/components/FavoriteButton";
import RelatedContentButton from "../../Content/components/RelatedContentButton";
import KnowledgeCardButton from "../../Content/components/KnowledgeCardButton";
import DeleteButton from "../../Content/components/DeleteButton";
import MoveButton from "../../Content/components/MoveButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import UploadFile from "../../Content/components/UploadFile";
import { ContentAttachment } from "../../../common/types";
import SaveButton from "../../Content/components/SaveButton";

interface OwnProps {
    onAttachmentUploaded: (a: ContentAttachment) => void;
    onLinkContent: () => void;
    onSave: () => void;
    isSaving: boolean;
}

export const ContentActionsButtons = ({ isSaving, onSave, onAttachmentUploaded, onLinkContent }: OwnProps) => {
    const [doesItFit] = useMediaQuery("(min-width: 1020px)");
    const [isShown, setIsShown] = useState(true);

    useEffect(() => {
        setIsShown(doesItFit);
    }, [doesItFit]);

    return (
        <>
            {!isShown && (
                <Button
                    variant="ghost"
                    onClick={() => {
                        setIsShown(true);
                    }}
                    leftIcon={<FontAwesomeIcon icon={faChevronRight} />}
                >
                    Acciones
                </Button>
            )}
            {isShown && (
                <>
                    {!doesItFit && (
                        <Button
                            variant="ghost"
                            onClick={() => {
                                setIsShown(false);
                            }}
                            leftIcon={<FontAwesomeIcon icon={faChevronLeft} />}
                        >
                            Acciones
                        </Button>
                    )}
                    <Flex
                        direction={doesItFit ? "row" : "column"}
                        marginY={4}
                        gap="4" justify="space-between"
                    >
                        <ButtonGroup
                            spacing={2}
                            size={"sm"}
                        >
                            <FavoriteButton />
                            <RelatedContentButton onLinkContent={onLinkContent} />
                            <KnowledgeCardButton />
                            <UploadFile onAttachmentUploaded={onAttachmentUploaded} />
                        </ButtonGroup>
                        <ButtonGroup
                            spacing={2}
                            size={"sm"}
                        >
                            <DeleteButton />
                            <MoveButton />
                            <SaveButton isSaving={isSaving} onSave={onSave} />
                        </ButtonGroup>
                    </Flex>
                </>
            )}
        </>
    );
};
